var common = require("../../../utiles/common.js");

function bindQR(params, url) {
  var $this = this;
  var random = common.urlSearch(location.href)["random"];
  var service = common.urlSearch(location.href)["service"];
  var callback = common.urlSearch(location.href)["callback"];
  var login_style = "";
  var search = window.location.href.split("?")[1];
  if (localStorage.getItem("loginTemplate") === "smallConcise") {
    login_style = "login_style=IOA&";
  }
  $this.urlParam =
    login_style && search ? "#/login?" + login_style + search : "#/login";
  $this.userKeypress = function (keyCode) {
    if (keyCode == 13) {
      $("input[type=password]").focus();
    }
  };
  $this.keypress = function (keyCode) {
    if (keyCode == 13) {
      $this.login();
    }
  };
  $this.loginBack = function (result, isAD) {
    if (result.data) {
      if (result.data.url) {
        common.redirectTo(result.data.url);
      }
      if (
        result.data.message &&
        result.data.message.replace(/^\s+|\s+$/g, "")
      ) {
        if (isAD) {
          common.message("error", result.data.message);
        } else {
          common.errorAlert(result.data.message);
        }
      }
    } else if (result.message) {
      common.errorAlert(result.message);
    } else {
      common.errorAlert(_i18n("异常错误"));
    }
  };
  $this.login = function () {
    var postD = $(".pwdLogin input").serializeObject();
    if (postD.password) {
      var pwdType = { decryptType: "SM2" };
      try {
        pwdType.cryptKey =
          "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
      } catch (error) {}
      console.info("postD.password", pwdType);
      postD.password = common.sm2.doCrypt(pwdType.cryptKey, postD.password);
    }
    postD.random = random;
    postD.service = service;
    postD.callback = callback;
    var searchUrl = window.location.href.split("?").splice(1).join("");
    common.fetch(url + "?" + searchUrl, {
      type: "POST",
      data: JSON.stringify(postD),
      handleError: function (data) {},
      success: function (result) {
        console.log(result);
        $this.loginBack(result);
      },
    });
  };
}

module.exports = {
  register: function () {
    document.createElement("wechat-bind");
    ko.components.register("wechat-bind", {
      viewModel: function (params) {
        bindQR(params, "/auth/qywx/scancode/login/pwd");
      },
      template: require("./WechatBind.html"),
    });
    document.createElement("ad-bind");
    ko.components.register("ad-bind", {
      viewModel: function (params) {
        bindQR(params, "/auth/associateAndFetchSso");
      },
      template: require("./ADBind.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatBind/BindQR.js
// module id = 127
// module chunks = 0